import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  BrowserAnimationsModule,
} from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PrivateModule } from './private/private.module';
import { PublicModule } from './public/public.module';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerInterceptor } from './models/interceptors/spinner.interceptor';
import { SpinnerModule } from './components/spinner/spinner.module';
import { FilePickerService } from 'ngx-awesome-uploader';
import { CommonModule } from '@angular/common';
import { GlobalPanicAlertComponent } from './shared/components/global-panic-alert/global-panic-alert.component';
import { AlarmPlayerComponent } from './components/alarm-player.component';

@NgModule({
  declarations: [AppComponent, GlobalPanicAlertComponent, AlarmPlayerComponent],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    AppRoutingModule,
    PublicModule,
    PrivateModule,
    SpinnerModule
  ],
  providers: [
    ApiService,
    AuthService,
    FilePickerService,
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
